<script lang="ts">
import { defineComponent } from "vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "ProduktmodulAusschluss",
  components: {},
  props: {
    produktmodulAuschluss: Object,
  },

  setup(props) {
    const piniaStore = useFormStore();

    return {
      piniaStore,
      props,
    };
  },
});
</script>

<template>
  <div
    class="o-grid"
    v-bind:class="{
      'u-mar-t-1': produktmodulAuschluss.modulPrefix === '',
      'u-mar-t-2': produktmodulAuschluss.modulPrefix !== '',
    }"
  >
    <div class="o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y">
      <h2 v-if="produktmodulAuschluss.modulPrefix !== ''" class="u-form-heading unset-text-align">
        {{ produktmodulAuschluss.modulPrefix }}
      </h2>
    </div>
    <div
      class="o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200"
      v-bind:class="{
        'u-form-grid-nospace-y': produktmodulAuschluss.modulPrefix === '',
        'u-form-grid-lowspace-y': produktmodulAuschluss.modulPrefix !== '',
      }"
    >
      <div class="gev19-optional-module">
        <div class="o-grid o-grid--no-y-gutter o-grid--align-flex-end">
          <div class="o-grid__cell o-grid__cell--12">
            <h3 v-if="!piniaStore.state.isMakler" class="u-mar-y-0" v-html="produktmodulAuschluss.name" />
            <h3 v-if="piniaStore.state.isMakler" class="u-mar-y-0" v-html="produktmodulAuschluss.nameMakler" />
            <p
              v-if="!piniaStore.state.isMakler || produktmodulAuschluss.bodyMakler === undefined"
              v-html="produktmodulAuschluss.body"
              class="u-mar-b-0"
            />
            <p v-else v-html="produktmodulAuschluss.bodyMakler" class="u-mar-b-0" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
